<div class="login-flow" *ngIf="!mfaAuthenticationProcess && currentUser">
  <h1 class="global-title">
    {{
      translate.currentLang === 'en'
        ? 'Set Up Your 4-Digit PIN'
        : 'আপনার 4-অঙ্কের PIN সেটআপ
    করুন'
    }}
  </h1>

  <p class="global-subheading">
    {{
      translate.currentLang === 'en'
        ? "You'll use this PIN every time you log in to verify
    your identity through Multi-Factor Authentication (MFA)"
        : 'আপনি আপনার পরিচয় যাচাই করার জন্য প্রতিবার লগইন করার
    সময় এই PIN ব্যবহার করবেন মাল্টি-ফ্যাক্টর অথেন্টিকেশন (MFA) এর মাধ্যমে'
    }}
  </p>
  <div class="text-block"></div>
  <div class="hr" style="margin-bottom: 1rem !important"></div>

  <app-mfa-configuration (emitEvent)="mfaConfigure()"></app-mfa-configuration>
</div>

<div class="login-flow" *ngIf="mfaAuthenticationProcess && currentUser">
  <div class="mb-3">
    <button type="button" (click)="goBackToLogin()" class="btn-back" [disabled]="mfaVerifying">
      <i class="fas fa-arrow-left"></i> {{ translate.currentLang === 'en' ? 'Back to Login' : 'লগইনে ফিরে যান' }}
    </button>
  </div>

  <h1 class="global-title">{{ translate.currentLang === 'en' ? 'MFA Authentication' : 'MFA অথেন্টিকেশন' }}</h1>
  <p class="global-subheading">
    {{
      translate.currentLang === 'en'
        ? 'Please enter the 4-digit PIN'
        : 'অনুগ্রহ করে
    4-অঙ্কের PIN লিখুন'
    }}
  </p>
  <div class="text-block"></div>
  <div class="hr" style="margin-bottom: 1rem !important"></div>
  <div class="mb-2">
    <app-set-pin
      *ngIf="forgotPin"
      [mfa]="true"
      (forgotPinStatus)="forgetPinFromSetPin()"
      (newPinEnterScreen)="newPinEnterScreenDone($event)"
    ></app-set-pin>
    <form
      *ngIf="mfaForm && !forgotPin"
      class="form digit-group d-flex flex-column align-items-center"
      #form="ngForm"
      [formGroup]="mfaForm"
      (ngSubmit)="verifyMFA(form)"
      novalidate
      [class.has-error]="mfaErrors"
    >
      <div class="mt-2 d-flex justify-content-center w-100" *ngIf="mfaValidationType === 'PIN'">
        <div formGroupName="pinCode" class="form-group d-flex justify-content-center align-items-center">
          <input
            #mfaPin1Row
            formControlName="pin1"
            autocomplete="new-password"
            name="pin1"
            type="text"
            pattern="[0-9]*"
            tabindex="1"
            maxlength="1"
            (keydown)="restrictInput($event, 0)"
            (input)="validateInput($event, 0, 'pinCode', 'pin1')"
            (paste)="blockPaste($event)"
          />

          <input
            #mfaPin2Row
            formControlName="pin2"
            autocomplete="off"
            name="pin2"
            type="text"
            pattern="[0-9]*"
            tabindex="2"
            maxlength="1"
            (keydown)="restrictInput($event, 1)"
            (input)="validateInput($event, 1, 'pinCode', 'pin2')"
            (paste)="blockPaste($event)"
          />

          <input
            #mfaPin3Row
            formControlName="pin3"
            autocomplete="off"
            name="pin3"
            type="text"
            pattern="[0-9]*"
            tabindex="3"
            maxlength="1"
            (keydown)="restrictInput($event, 2)"
            (input)="validateInput($event, 2, 'pinCode', 'pin3')"
            (paste)="blockPaste($event)"
          />

          <input
            #mfaPin4Row
            formControlName="pin4"
            autocomplete="off"
            name="pin4"
            type="text"
            pattern="[0-9]*"
            tabindex="4"
            maxlength="1"
            (keydown)="restrictInput($event, 3)"
            (input)="validateInput($event, 3, 'pinCode', 'pin4')"
            (paste)="blockPaste($event)"
          />
        </div>

        <errors
          class="pin-error-message"
          [on]="
            form.submitted &&
            (mfaForm.get('pinCode.pin1')?.invalid ||
              mfaForm.get('pinCode.pin2')?.invalid ||
              mfaForm.get('pinCode.pin3')?.invalid ||
              mfaForm.get('pinCode.pin4')?.invalid)
          "
        >
          {{ translate.currentLang === 'en' ? 'Required' : 'আবশ্যক' }}
        </errors>
      </div>

      <div class="mfa-error-container" [hidden]="!mfaErrors" [class.show]="mfaErrors">
        <div class="mfa-error-content">
          <div class="mfa-error-message">{{ mfaErrors }}</div>
        </div>
      </div>
      <div class="button-row">
        <app-primary-button
          id="btn-l-1"
          [text]="translate.currentLang === 'en' ? 'Verify and Continue' : 'যাচাই করুন এবং চালিয়ে যান'"
          [loading]="mfaVerifying"
          type="submit"
          [fullWidth]="true"
          [disabled]="resendingVerificationCodes"
        >
        </app-primary-button>
      </div>
      <div class="button-row" *ngIf="mfaValidationType === 'PIN'">
        <button type="button" [hidden]="mfaVerifying" (click)="forgotPinView()" class="btn global-gray-button">
          {{ translate.currentLang === 'en' ? 'Forgot PIN?' : 'PIN ভুলে গেছেন?' }}
        </button>
      </div>
      <div class="mt-2" *ngIf="mfaValidationType === 'OTP'">
        <span>{{ translate.currentLang === 'en' ? "Didn't receive the OTP?" : 'OTP পাননি?' }}</span>
        <span (click)="sendVerificationCodes()" class="resend-otp">
          {{ translate.currentLang === 'en' ? 'Resend OTP' : 'OTP পুনরায় পাঠান' }}
          <span class="loader inline-loader" [hidden]="!resendingVerificationCodes"></span>
        </span>
      </div>
    </form>
  </div>
</div>
